// aws-exports.js
// AWS Cognito configuration for Amplify v6.
//
// Dev and prod SHARE one Cognito user pool (us-east-1_C0fdh1u5t).
//
// History: a separate dev pool (us-east-1_wEsRP3HbT) was created so Cognito
// passkeys could bind to dev123bimlive.com (a WebAuthn relying-party ID is one
// domain per pool). That approach was abandoned — Cognito refuses WEB_AUTHN as a
// first factor for users who have TOTP MFA activated, and TOTP is mandatory here.
// Biometrics are instead a LOCAL app unlock (utils/appLock.js) which needs no
// Cognito configuration and works on any domain. The split then only cost us:
// the 38 real accounts live in the prod pool, so the dev stack locked everyone
// out. Reverted to the shared pool; the dev pool is now unused.
const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_C0fdh1u5t',
      userPoolClientId: '25hfbmls764po68odtpdoqngpm',
      // v6: no mandatorySignIn / authenticationFlowType here — the auth flow is
      // chosen per signIn() call (default USER_SRP_AUTH).
    },
  },
};

export default awsconfig;
